import {i18n} from "@/plugins/i18n";

export const RolesConstant = {
    TECH_SUPPORT: 'tech-support',
    ACCOUNTING: 'accountant',
    WALLET_OPERATOR: 'wallet-operator',
    IPG_GATEWAY_MANAGER: 'ipg-gateway-manager',
    IVR_GATEWAY_MANAGER: 'ivr-gateway-manager',
    CARD_TO_CARD_GATEWAY_MANAGER: 'card-to-card-gateway-manager',
    USER_MANAGER: 'user-manager',
    TICKET_MANAGER: 'ticket-manager',
    TRANSACTION_MANAGER: 'transaction-manager',
    SETTLEMENT_MANAGER: 'settlement-manager',
    PAYMENT_LINK_MANAGER: 'payment-link-manager',
    NOTIFICATION_MANAGER: 'notification-manager',
    CONTRACT_MANAGER: 'contract-manager',
    MARKETING_MANAGER: 'marketing-manager',
    CUSTOMER_CLUB_MANAGER: 'customer-club-manager',
    MONITORING_MANAGER: 'monitoring-manager',
    WALLET_MANAGER: 'wallet-manager',
    SECURITY_MANAGER: 'security-manager',
    KNOWLEDGE_MANAGEMENT: 'knowledge-management',
    BUSINESS_MANAGEMENT: 'business-management',
};

export const PermissionsConstant = {
    WALLET_READ: 'wallet.read',
    WALLET_CHANGE_SETTING: 'wallet.change-setting',
    WALLET_CHANGE_STATUS: 'wallet.change-status',
    WALLET_MANAGE_SETTLEMENT: 'wallet.manage-settlement',
    WALLET_RECEIVE_TELEGRAM_NOTIFICATION: 'wallet.receive-telegram-notification',
    WALLET_RECEIVE_SMS_NOTIFICATION: 'wallet.receive-sms-notification',
    WALLET_WALLET_TO_WALLET: 'wallet.wallet-to-wallet',
    WALLET_CREATE: 'wallet.create',
    WALLET_CREATE_WALLET_IN_PANEL: 'wallet.create-wallet-in-panel',
    WALLET_CHARGE_USER_WALLET_BY_RECEIPT: 'wallet.charge-user-wallet-by-receipt',
    WALLET_READ_WALLET_LIST: 'wallet.read-wallet-list',
    WALLET_READ_BANK_STATEMENTS: 'wallet.read-bank-statements',
    WALLET_MANAGE_BANKS: 'wallet.manage-banks',
    WALLET_READ_SETTLEMENT_AND_CHARGE_LIST: 'wallet.read-settlement-and-charge-list',
    WALLET_READ_ACCOUNT_BALANCE_RECONCILIATION: 'wallet.read-account-balance-reconciliation',
    WALLET_READ_GENERAL_SETTINGS: 'wallet.read-general-settings',
    WALLET_READ_GENERAL_WAGE_SETTINGS: 'wallet.read-general-wage-settings',
    WALLET_READ_CUSTOM_WAGE_SETTINGS: 'wallet.read-custom-wage-settings',
    WALLET_READ_SPECIFIC_SETTINGS: 'wallet.read-specific-settings',
    WALLET_MANAGE_UPCOMING_SETTLEMENT_SETTINGS: 'wallet.manage-upcoming-settlement-settings',
    WALLET_MANAGE_SETTLEMENT_LIMIT_SETTINGS: 'wallet.manage-settlement-limit-settings',
    WALLET_MANAGE_INTERBANK_TRANSFER: 'wallet.manage-interbank-transfer',
    WALLET_MANAGE_PAYMENT_SETTLEMENT_REQUESTS: 'wallet.manage-payment-settlement-requests',
    WALLET_CHANGE_STATUS_ALL_WALLETS: 'wallet.change-status-all-wallets',
    WALLET_READ_STATISTICS: 'wallet.read-statistics',
    WALLET_EXPORT_EXCEL: 'wallet.export-excel',
    WALLET_READ_SETTLEMENT_DETAILS: 'wallet.read-settlement-details',
    WALLET_MANAGE_WALLET_ACCESS: 'wallet.manage-wallet-access',
    WALLET_CHANGE_BLOCKED_AMOUNT_SETTING: 'wallet.change-blocked-amount-setting',
    WALLET_CHANGE_GENERAL_SETTING: 'wallet.change-general-setting',
    WALLET_CHANGE_GENERAL_WAGE_SETTING: 'wallet.change-general-wage-setting',
    WALLET_CHANGE_SPECIFIC_SETTING: 'wallet.change-specific-setting',
    WALLET_CHANGE_SPECIFIC_WAGE_SETTING: 'wallet.change-specific-wage-setting',

    USER_CREATE: 'user.create',
    USER_READ_GENERAL_INFO: 'user.read-general-info',
    USER_READ_SENSITIVE_INFO: 'user.read-sensitive-info',
    USER_UPDATE: 'user.update',
    USER_CHANGE_PASSWORD: 'user.change-password',
    USER_LOGIN_TO_USER_PANEL: 'user.login-to-user-panel',
    USER_CHANGE_ACCESS: 'user.change-access',
    USER_CHANGE_WALLET_ACCESS: 'user.change-wallet-access',
    USER_CHANGE_ACCOUNTING_ACCESS: 'user.change-accounting-access',
    USER_CHANGE_MONITORING_ACCESS: 'user.change-monitoring-access',
    USER_RECEIVE_CHANGE_ACCESS_NOTIFICATION: 'user.receive-change-access-notification',
    USER_CHANGE_PHONE_NUMBER: 'user.change-phone-number',
    USER_EXPORT_EXCEL_GENERAL_INFO: 'user.export-excel-general-info',
    USER_EXPORT_EXCEL_ALL_INFO: 'user.export-excel-all-info',
    USER_MANAGE_USER_CATEGORY: 'user.manage-user-category',
    USER_MANAGE_STAKEHOLDER: 'user.manage-stakeholder',
    USER_MANAGE_APPLICATION_TOKEN: 'user.manage-application-token',

    ACCOUNTING_READ: 'accounting.read',
    ACCOUNTING_CHANGE_SETTING: 'accounting.change-setting',
    ACCOUNTING_CREATE_BANK_ACCOUNT: 'accounting.create-bank-account',
    ACCOUNTING_DELETE_BANK_ACCOUNT: 'accounting.delete-bank-account',
    ACCOUNTING_UPDATE_BANK_ACCOUNT: 'accounting.update-bank-account',
    ACCOUNTING_DELETE_TRANSACTION: 'accounting.delete-transaction',
    ACCOUNTING_UPDATE_TRANSACTION: 'accounting.update-transaction',
    ACCOUNTING_CREATE_TRANSACTION: 'accounting.create-transaction',
    ACCOUNTING_RECEIVE_NOTIFICATION: 'accounting.receive-notification',

    TRANSACTION_READ: 'transaction.read',
    TRANSACTION_READ_TRANSACTION_LOGS: 'transaction.read-transaction-log',
    TRANSACTION_MANAGE_TRANSACTION_SETTING: 'transaction.manage-transaction-setting',
    TRANSACTION_EXPORT_EXCEL: 'transaction.export-excel',
    TRANSACTION_READ_WAGES: 'transaction.read-wages',
    TRANSACTION_READ_STATISTICS: 'transaction.read-statistics',
    TRANSACTION_CHANGE_STATUS: 'transaction.change-status',
    TRANSACTION_INQUIRY_TRANSACTION: 'transaction.inquiry-transaction',

    IPG_GATEWAY_READ: 'ipg-gateway.read',
    IPG_GATEWAY_UPDATE_INFO: 'ipg-gateway.update-info',
    IPG_GATEWAY_CHANGE_WAGE_SETTING: 'ipg-gateway.change-wage-setting',
    IPG_GATEWAY_CHANGE_STATUS: 'ipg-gateway.change-status',
    IPG_GATEWAY_EXPORT_EXCEL: 'ipg-gateway.export-excel',
    IPG_GATEWAY_MANAGE_COLLECTIVE_GATEWAYS: 'ipg-gateway.manage-collective-gateways',

    WALLET_OPERATOR_READ: 'wallet-operator.read',
    WALLET_OPERATOR_CHANGE_SETTING: 'wallet-operator.change-setting',
    WALLET_OPERATOR_CHANGE_STATUS: 'wallet-operator.change-status',
    WALLET_OPERATOR_READ_WALLET_LIST: 'wallet-operator.read-wallet-list',
    WALLET_OPERATOR_READ_BANK_STATEMENTS: 'wallet-operator.read-bank-statements',
    WALLET_OPERATOR_READ_SETTLEMENT_AND_CHARGE_LIST: 'wallet-operator.read-settlement-and-charge-list',
    WALLET_OPERATOR_READ_ACCOUNT_BALANCE_RECONCILIATION: 'wallet-operator.read-account-balance-reconciliation',
    WALLET_OPERATOR_READ_GENERAL_SETTINGS: 'wallet-operator.read-general-settings',
    WALLET_OPERATOR_READ_GENERAL_WAGE_SETTINGS: 'wallet-operator.read-general-wage-settings',
    WALLET_OPERATOR_READ_CUSTOM_WAGE_SETTINGS: 'wallet-operator.read-custom-wage-settings',
    WALLET_OPERATOR_READ_SPECIFIC_SETTINGS: 'wallet-operator.read-specific-settings',
    WALLET_OPERATOR_READ_SETTLEMENT_DETAILS: 'wallet-operator.read-settlement-details',

    IVR_GATEWAY_READ: 'ivr-gateway.read',
    IVR_GATEWAY_UPDATE_INFO: 'ivr-gateway.update-info',
    IVR_GATEWAY_CHANGE_WAGE_SETTING: 'ivr-gateway.change-wage-setting',
    IVR_GATEWAY_CHANGE_STATUS: 'ivr-gateway.change-status',
    IVR_GATEWAY_EXPORT_EXCEL: 'ivr-gateway.export-excel',

    CARD_TO_CARD_GATEWAY_READ: 'card-to-card-gateway.read',
    CARD_TO_CARD_GATEWAY_UPDATE_INFO: 'card-to-card-gateway.update-info',
    CARD_TO_CARD_GATEWAY_CHANGE_WAGE_SETTING: 'card-to-card-gateway.change-wage-setting',
    CARD_TO_CARD_GATEWAY_CHANGE_STATUS: 'card-to-card-gateway.change-status',
    CARD_TO_CARD_GATEWAY_EXPORT_EXCEL: 'card-to-card-gateway.export-excel',

    SETTLEMENT_READ: 'settlement.read',
    SETTLEMENT_CHANGE_STATUS: 'settlement.change-status',
    SETTLEMENT_READ_SHAPARAK_FILES: 'settlement.read-shaparak-files',
    SETTLEMENT_EXPORT_EXCEL: 'settlement.export-excel',
    SETTLEMENT_MANAGE_PSP_CUT_OFF: 'settlement.manage-psp-cut-off',

    TECH_SUPPORT_RUN_WALLET_MANUAL_CHARGE: 'tech-support.run-wallet-manual-charge',
    TECH_SUPPORT_RUN_AUTO_SETTLEMENT_CREATION: 'tech-support.run-auto-settlement-creation',

    SECURITY_MANAGE_BLACK_LIST: 'security.manage-black-list',
    SECURITY_MANAGE_FRAUD_EVENTS: 'security.manage-fraud-events',
    SECURITY_MANAGE_USER_LIMITATION: 'security.manage-user-limitation',

    TICKET_READ: 'ticket.read',
    TICKET_MANAGE_CATEGORY: 'ticket.manage-category',
    TICKET_COMMENT_DELETE: 'ticket.comment-delete',

    PAYMENT_LINK_READ: 'payment-link.read',
    PAYMENT_LINK_CHANGE_SETTING: 'payment-link.change-setting',

    NOTIFICATION_READ: 'notification.read',
    NOTIFICATION_CHANGE_SETTING: 'notification.change-setting',
    NOTIFICATION_READ_SENSITIVE_DATA: 'notification.read-sensitive-data',

    CONTRACT_READ: 'contract-manager.read',
    CONTRACT_UPDATE: 'contract-manager.update',

    MARKETING_READ: 'marketing.read',
    MARKETING_CHANGE_SETTINGS: 'marketing.change-settings',

    CUSTOMER_CLUB_READ: 'customer-club.read',
    CUSTOMER_CLUB_CHANGE_SETTING: 'customer-club.change-setting',

    MONITORING_READ_TELESCOPE: 'monitoring.read-telescope',

    KNOWLEDGE_MANAGEMENT_MANAGE_QUESTIONS: 'knowledge-management.manage-questions',
    KNOWLEDGE_MANAGEMENT_MANAGE_FAQ: 'knowledge-management.manage-faq',

    BUSINESS_BANNER_READ: 'business.read',
    BUSINESS_BANNER_UPDATE: 'business.update',
    BUSINESS_BANNER_DELETE: 'business.delete'
};

export const RolesArray = [
    {
        key: RolesConstant.USER_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.USER_MANAGER),
        permissions: [
            { key: 'user.create', name: i18n.t('permissions.create') },
            { key: 'user.read-general-info', name: i18n.t('permissions.read-general-info') },
            { key: 'user.read-sensitive-info', name: i18n.t('permissions.read-sensitive-info') },
            { key: 'user.update', name: i18n.t('permissions.update') },
            { key: 'user.change-password', name: i18n.t('permissions.change-password') },
            { key: 'user.login-to-user-panel', name: i18n.t('permissions.login-to-user-panel') },
            { key: 'user.change-access', name: i18n.t('permissions.change-access') },
            { key: 'user.change-accounting-access', name: i18n.t('permissions.change-accounting-access') },
            { key: 'user.change-monitoring-access', name: i18n.t('permissions.change-monitoring-access') },
            { key: 'user.receive-change-access-notification', name: i18n.t('permissions.receive-change-access-notification') },
            { key: 'user.change-phone-number', name: i18n.t('permissions.change-phone-number') },
            { key: 'user.export-excel-general-info', name: i18n.t('permissions.export-excel-general-info') },
            { key: 'user.export-excel-all-info', name: i18n.t('permissions.export-excel-all-info') },
            { key: 'user.manage-user-category', name: i18n.t('permissions.manage-user-category') },
            { key: 'user.manage-stakeholder', name: i18n.t('permissions.manage-stakeholder') },
            { key: 'user.manage-application-token', name: i18n.t('permissions.manage-application-token') }
        ]
    },
    {
        key: RolesConstant.ACCOUNTING,
        name: i18n.t('label.roles.' + RolesConstant.ACCOUNTING),
        permissions: [
            { key: 'accounting.read', name: i18n.t('permissions.read') },
            { key: 'accounting.change-setting', name: i18n.t('permissions.change-setting') },
            { key: 'accounting.create-bank-account', name: i18n.t('permissions.create-bank-account') },
            { key: 'accounting.delete-bank-account', name: i18n.t('permissions.delete-bank-account') },
            { key: 'accounting.update-bank-account', name: i18n.t('permissions.update-bank-account') },
            { key: 'accounting.delete-transaction', name: i18n.t('permissions.delete-transaction') },
            { key: 'accounting.update-transaction', name: i18n.t('permissions.update-transaction') },
            { key: 'accounting.create-transaction', name: i18n.t('permissions.create-transaction') },
            { key: 'accounting.receive-notification', name: i18n.t('permissions.receive-notification') },
        ]
    },
    {
        key: RolesConstant.TRANSACTION_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.TRANSACTION_MANAGER),
        permissions: [
            { key: 'transaction.read', name: i18n.t('permissions.read') },
            { key: 'transaction.read-transaction-log', name: i18n.t('permissions.read-transaction-log') },
            { key: 'transaction.manage-transaction-setting', name: i18n.t('permissions.manage-transaction-setting') },
            { key: 'transaction.export-excel', name: i18n.t('permissions.export-excel') },
            { key: 'transaction.read-wages', name: i18n.t('permissions.read-wages') },
            { key: 'transaction.read-statistics', name: i18n.t('permissions.read-statistics') },
            { key: 'transaction.change-status', name: i18n.t('permissions.change-status') },
            { key: 'transaction.inquiry-transaction', name: i18n.t('permissions.inquiry-transaction') }
        ]
    },
    {
        key: RolesConstant.IPG_GATEWAY_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.IPG_GATEWAY_MANAGER),
        permissions: [
            { key: 'ipg-gateway.read', name: i18n.t('permissions.read') },
            { key: 'ipg-gateway.update-info', name: i18n.t('permissions.update-info') },
            { key: 'ipg-gateway.change-wage-setting', name: i18n.t('permissions.change-wage-setting') },
            { key: 'ipg-gateway.change-status', name: i18n.t('permissions.change-status') },
            { key: 'ipg-gateway.export-excel', name: i18n.t('permissions.export-excel') }
        ]
    },
    // {
    //     key: RolesConstant.IVR_GATEWAY_MANAGER,
    //     name: i18n.t('label.roles.' + RolesConstant.IVR_GATEWAY_MANAGER),
    //     permissions: [
    //         { key: 'ivr-gateway.read', name: i18n.t('permissions.read') },
    //         { key: 'ivr-gateway.update-info', name: i18n.t('permissions.update-info') },
    //         { key: 'ivr-gateway.change-wage-setting', name: i18n.t('permissions.change-wage-setting') },
    //         { key: 'ivr-gateway.change-status', name: i18n.t('permissions.change-status') },
    //         { key: 'ivr-gateway.export-excel', name: i18n.t('permissions.export-excel') }
    //     ]
    // },
    // {
    //     key: RolesConstant.CARD_TO_CARD_GATEWAY_MANAGER,
    //     name: i18n.t('label.roles.' + RolesConstant.CARD_TO_CARD_GATEWAY_MANAGER),
    //     permissions: [
    //         { key: 'card-to-card-gateway.read', name: i18n.t('permissions.read') },
    //         { key: 'card-to-card-gateway.update-info', name: i18n.t('permissions.update-info') },
    //         { key: 'card-to-card-gateway.change-wage-setting', name: i18n.t('permissions.change-wage-setting') },
    //         { key: 'card-to-card-gateway.change-status', name: i18n.t('permissions.change-status') },
    //         { key: 'card-to-card-gateway.export-excel', name: i18n.t('permissions.export-excel') }
    //     ]
    // },
    {
        key: RolesConstant.SETTLEMENT_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.SETTLEMENT_MANAGER),
        permissions: [
            { key: 'settlement.read', name: i18n.t('permissions.read') },
            { key: 'settlement.change-status', name: i18n.t('permissions.change-status') },
            { key: 'settlement.read-shaparak-files', name: i18n.t('permissions.read-shaparak-files') },
            { key: 'settlement.export-excel', name: i18n.t('permissions.export-excel') },
            { key: 'settlement.manage-psp-cut-off', name: i18n.t('permissions.manage-psp-cut-off') }
        ]
    },
    {
        key: RolesConstant.SECURITY_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.SECURITY_MANAGER),
        permissions: [
            { key: 'security.manage-black-list', name: i18n.t('permissions.manage-black-list') },
            { key: 'security.manage-fraud-events', name: i18n.t('permissions.manage-fraud-events') },
            { key: 'security.manage-user-limitation', name: i18n.t('permissions.manage-user-limitation') }
        ]
    },
    {
        key: RolesConstant.TICKET_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.TICKET_MANAGER),
        permissions: [
            { key: 'ticket.read', name: i18n.t('permissions.read') },
            { key: 'ticket.manage-category', name: i18n.t('permissions.manage-category') },
            { key: 'ticket.comment-delete', name: i18n.t('permissions.comment-delete') },
        ]
    },
    {
        key: RolesConstant.NOTIFICATION_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.NOTIFICATION_MANAGER),
        permissions: [
            { key: 'notification.read', name: i18n.t('permissions.read') },
            { key: 'notification.change-setting', name: i18n.t('permissions.change-setting') },
            { key: 'notification.read-sensitive-data', name: i18n.t('permissions.read-sensitive-data') }
        ]
    },
    {
        key: RolesConstant.CONTRACT_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.CONTRACT_MANAGER),
        permissions: [
            { key: 'contract-manager.read', name: i18n.t('permissions.read') },
            { key: 'contract-manager.update', name: i18n.t('permissions.update') }
        ]
    },
    {
        key: RolesConstant.MARKETING_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.MARKETING_MANAGER),
        permissions: [
            { key: 'marketing.read', name: i18n.t('permissions.read') },
            { key: 'marketing.change-settings', name: i18n.t('permissions.change-settings') }
        ]
    },
    {
        key: RolesConstant.CUSTOMER_CLUB_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.CUSTOMER_CLUB_MANAGER),
        permissions: [
            { key: 'customer-club.read', name: i18n.t('permissions.read') },
            { key: 'customer-club.change-setting', name: i18n.t('permissions.change-setting') }
        ]
    },
    {
        key: RolesConstant.KNOWLEDGE_MANAGEMENT,
        name: i18n.t('label.roles.' + RolesConstant.KNOWLEDGE_MANAGEMENT),
        permissions: [
            { key: 'knowledge-management.manage-questions', name: i18n.t('permissions.manage-questions') },
            { key: 'knowledge-management.manage-faq', name: i18n.t('permissions.manage-faq') }
        ]
    },
    {
        key: RolesConstant.MONITORING_MANAGER,
        name: i18n.t('label.roles.' + RolesConstant.MONITORING_MANAGER),
        permissions: [
            { key: 'monitoring.read-telescope', name: i18n.t('permissions.read-telescope') }
        ]
    },
    {
        key: RolesConstant.BUSINESS_MANAGEMENT,
        name: i18n.t('label.roles.' + RolesConstant.BUSINESS_MANAGEMENT),
        permissions: [
            { key: 'business.read', name: i18n.t('permissions.read-business') },
            { key: 'business.update', name: i18n.t('permissions.update-business') },
            { key: 'business.delete', name: i18n.t('permissions.delete-business') }
        ]
    },
];